import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { SaleStore } from '@/types/stores/sale/sale.store';

export const useSaleStore = create<SaleStore>()(
  persist(
    (set) => ({
      saleId: null,

      setSaleId: (saleId) => set({ saleId }),
      resetSaleId: () => set({ saleId: null }),
    }),
    { name: 'sale-store' },
  ),
);
